var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexalSpiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 786,
    height: 800,
    viewBox: "0 0 786 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08,
    clipPath: "url(#clip0_721_3461)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M661.17 98.4848L776.706 501.403L485.535 802.919L78.8301 701.515L-36.7053 298.597L254.465 -2.91858L661.17 98.4848Z",
    stroke: "url(#paint0_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M637.721 102.666L761.36 483.187L493.639 780.521L102.279 697.335L-21.3603 316.814L246.361 19.4791L637.721 102.666Z",
    stroke: "url(#paint1_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M614.935 108.098L745.262 466.169L500.328 758.071L125.066 691.902L-5.26184 333.831L239.673 41.9293L614.935 108.098Z",
    stroke: "url(#paint2_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M592.868 114.742L728.476 450.381L505.607 735.639L147.132 685.259L11.5246 349.619L234.393 64.361L592.868 114.742Z",
    stroke: "url(#paint3_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M571.578 122.551L711.067 435.848L509.489 713.297L168.422 677.449L28.9329 364.152L230.511 86.7035L571.578 122.551Z",
    stroke: "url(#paint4_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M551.119 131.481L693.105 422.594L511.986 691.114L188.881 668.52L46.8957 377.406L228.014 108.887L551.119 131.481Z",
    stroke: "url(#paint5_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M531.541 141.481L674.655 410.639L513.114 669.159L208.459 658.52L65.3449 389.361L226.886 130.842L531.541 141.481Z",
    stroke: "url(#paint6_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M512.894 152.5L655.788 400L512.894 647.5L227.106 647.5L84.2117 400L227.106 152.5L512.894 152.5Z",
    stroke: "url(#paint7_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M495.225 164.487L636.573 390.691L511.349 626.205L244.775 635.514L103.427 409.309L228.652 173.795L495.225 164.487Z",
    stroke: "url(#paint8_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M478.577 177.384L617.08 382.723L508.503 605.339L261.423 622.616L122.92 417.277L231.497 194.662L478.577 177.384Z",
    stroke: "url(#paint9_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M462.992 191.136L597.378 376.102L504.386 584.966L277.008 608.864L142.622 423.898L235.614 215.034L462.992 191.136Z",
    stroke: "url(#paint10_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M448.509 205.683L577.539 370.833L499.029 565.15L291.491 594.317L162.462 429.168L240.971 234.85L448.509 205.683Z",
    stroke: "url(#paint11_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M435.164 220.965L557.631 366.916L492.468 545.951L304.837 579.035L182.369 433.084L247.533 254.049L435.164 220.965Z",
    stroke: "url(#paint12_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M422.988 236.92L537.726 364.349L484.738 527.429L317.012 563.08L202.274 435.651L255.262 272.571L422.988 236.92Z",
    stroke: "url(#paint13_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M412.013 253.484L517.893 363.126L475.88 509.642L327.987 546.516L222.107 436.874L264.12 290.358L412.013 253.484Z",
    stroke: "url(#paint14_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M402.265 270.594L498.202 363.239L465.937 492.645L337.736 529.406L241.799 436.761L274.063 307.355L402.265 270.594Z",
    stroke: "url(#paint15_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M393.768 288.183L478.72 364.675L454.953 476.492L346.233 511.817L261.28 435.325L285.047 323.508L393.768 288.183Z",
    stroke: "url(#paint16_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M386.542 306.185L459.518 367.418L442.976 461.234L353.458 493.815L280.482 432.582L297.025 338.766L386.542 306.185Z",
    stroke: "url(#paint17_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M380.606 324.532L440.661 371.451L430.055 446.92L359.394 475.469L299.339 428.549L309.946 353.08L380.606 324.532Z",
    stroke: "url(#paint18_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M375.975 343.156L422.216 376.752L416.242 433.596L364.025 456.845L317.784 423.248L323.759 366.404L375.975 343.156Z",
    stroke: "url(#paint19_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M372.658 361.988L404.249 383.296L401.591 421.308L367.342 438.012L335.751 416.704L338.409 378.692L372.658 361.988Z",
    stroke: "url(#paint20_linear_721_3461)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.665 380.959L386.822 391.055L386.158 410.096L369.335 419.041L353.178 408.945L353.843 389.904L370.665 380.959Z",
    stroke: "url(#paint21_linear_721_3461)",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_3461",
    x1: 661.17,
    y1: 98.4848,
    x2: 78.8301,
    y2: 701.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_721_3461",
    x1: 637.721,
    y1: 102.666,
    x2: 102.279,
    y2: 697.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_721_3461",
    x1: 614.935,
    y1: 108.098,
    x2: 125.066,
    y2: 691.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_721_3461",
    x1: 592.868,
    y1: 114.742,
    x2: 147.132,
    y2: 685.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_721_3461",
    x1: 571.578,
    y1: 122.551,
    x2: 168.422,
    y2: 677.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_721_3461",
    x1: 551.119,
    y1: 131.481,
    x2: 188.881,
    y2: 668.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_721_3461",
    x1: 531.541,
    y1: 141.481,
    x2: 208.459,
    y2: 658.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_721_3461",
    x1: 512.894,
    y1: 152.5,
    x2: 227.106,
    y2: 647.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_721_3461",
    x1: 495.225,
    y1: 164.487,
    x2: 244.775,
    y2: 635.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_721_3461",
    x1: 478.577,
    y1: 177.384,
    x2: 261.423,
    y2: 622.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_721_3461",
    x1: 462.992,
    y1: 191.136,
    x2: 277.008,
    y2: 608.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_721_3461",
    x1: 448.509,
    y1: 205.683,
    x2: 291.491,
    y2: 594.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_721_3461",
    x1: 435.164,
    y1: 220.965,
    x2: 304.837,
    y2: 579.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_721_3461",
    x1: 422.988,
    y1: 236.92,
    x2: 317.012,
    y2: 563.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_721_3461",
    x1: 412.013,
    y1: 253.484,
    x2: 327.987,
    y2: 546.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_721_3461",
    x1: 402.265,
    y1: 270.594,
    x2: 337.736,
    y2: 529.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_721_3461",
    x1: 393.768,
    y1: 288.183,
    x2: 346.233,
    y2: 511.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_721_3461",
    x1: 386.542,
    y1: 306.185,
    x2: 353.458,
    y2: 493.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_721_3461",
    x1: 380.606,
    y1: 324.532,
    x2: 359.394,
    y2: 475.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_721_3461",
    x1: 375.975,
    y1: 343.156,
    x2: 364.025,
    y2: 456.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_721_3461",
    x1: 372.658,
    y1: 361.988,
    x2: 367.342,
    y2: 438.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_721_3461",
    x1: 370.665,
    y1: 380.959,
    x2: 369.335,
    y2: 419.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42A8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_3461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white",
    transform: "translate(-14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexalSpiral);
export default __webpack_public_path__ + "static/media/hexal-spiral.912598fd3d4c7c16cb599e1daa119250.svg";
export { ForwardRef as ReactComponent };